import React, { Component } from 'react'
import PropTypes from 'prop-types'

// import SimpleHeader from '../SimpleHeader'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'

// Elements
import Panel from '../../../elements/panel'
import Inline from '../../../elements/inline'
import { ReferenceIcons } from '../../../elements/icons'

class ReferencedFrom extends Component {
  render () {
    const { department } = this.props

    var moveType = ''
    switch (this.props.referenceInfo.MoveType) {
      case 1:
        moveType = '703'
        break
      case 0:
        moveType = '778'
        break
    }

    const icon = department === 0 ? ReferenceIcons.Referred_From : null

    return (
      <Panel title={translation('719')} icon={icon}>
        {/* <SimpleHeader title={translation('719')} src='images/svgs/referal/referred-order.svg' /> */}
        <div className='clearfix'>
          <label className='full'>{this.props.referenceInfo.TransferedFromCompanyName}</label>

          {this.props.department === 0 && (
            <label className='full'>{translation(moveType)}</label>
          )}

          <Inline fillChildNum={[0, 1]} block>
            <span>{translation('30')}:</span>
            <span>{this.props.referenceInfo.CreatedBy}</span>
          </Inline>

          <Inline fillChildNum={[0, 1]} block>
            <span>{translation('388')}:</span>
            <span>{renderFullDate(this.props.referenceInfo.CreationDate)}</span>
          </Inline>
        </div>
      </Panel>
    )
  }
}

ReferencedFrom.propTypes = {
  referenceInfo: PropTypes.object.isRequired
}

export default ReferencedFrom



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferencedFrom/index.js